import { IStyle } from 'Styles';
import { IBasePropertyDTO } from 'business/models/Models';

import React from 'react';
import PropertyView from './PropertyView';

interface Props {
  propertiesList: IBasePropertyDTO[];
  robotId: number;
  plateId?: number;
  liquidClassId?: number;
  onChangeProp?: (
    property,
    e,
    robotId: number,
    plateId?: number,
    liquidClassId?: number,
  ) => void;
}

const PropertyWrapper = (props: Props) => {
  const { propertiesList, robotId, plateId, liquidClassId, onChangeProp } = props;

  if (!propertiesList) {
    return;
  }

  const view = propertiesList.map((prop) => {
    return (
      <div
        id="propertywrapper-property-container"
        key={prop.name + '_div'}
        style={styles.propertyRow}
      >
        <label
          id="propertywrapper-property-displayname"
          key={prop.name + '_label'}
          className="text-label flex-50"
        >
          {prop.displayName}
        </label>
        <PropertyView
          property={prop}
          onChangeProp={onChangeProp}
          robotId={robotId}
          plateId={plateId}
          liquidClassId={liquidClassId}
        />
      </div>
    );
  });

  return (
    <div id="propertywrapper-container" className="flex flex-col gap-3">
      {view}
    </div>
  );
};

const styles: IStyle = {
  root: {
    fontWeight: 700,
    color: '#F7A246',
    padding: '15px 10px',
    background: '#E4E4E4',
  },
  propertyLabel: { flex: '50%', textAlign: 'center', fontWeight: 700 },
  propertyContainer: {
    height: '85%',
    width: '99%',
    overflowY: 'auto',
    gap: '0.5rem',
    flexDirection: 'column',
  },
  propertyHeader: {
    height: '5%',
    width: '100%',
    overflowY: 'auto',
    gap: '0.5rem',
    flexDirection: 'row',
    background: '#D9D9D9',
    alignItems: 'center',
  },
  deviceLabel: {
    fontWeight: 400,
    fontSize: 13,
    padding: 0,
    width: '49%',
  },
  propertyRow: { display: 'flex', flexWrap: 'wrap', alignItems: 'baseline' },
};

export default PropertyWrapper;
